import { IOptionValue } from '../../../../../../component/admin-module/module/users/interface/field'
import { FormEnumLabel } from '../../../../../../component/document-module/module/form/utils/manage-enum-id-label';

export const setTableEnumOptions = (tableFieldEnumOptionsRef: any, retOptions: IOptionValue[], tableId: string, fieldId: string) => {
  const oldOptions = tableFieldEnumOptionsRef.current[tableId][fieldId] || []
  const enumItems: any[] = FormEnumLabel.getUniqueEnumItem([...oldOptions, ...retOptions || []], 'id');
  tableFieldEnumOptionsRef.current[tableId][fieldId] = enumItems;
}